import { Component } from '@angular/core'
import {ControlWidget} from 'ngx-schema-form'

@Component({
  selector: 'my-custom-radio',
  template: `
      <div class="ui-g-12 sf-field-container flex-align-center">
        <div class="ui-g-12 ui-md-4">
          <span class="label">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <p-checkbox
            [name]="name"
            [formControl]="control"
            [binary]="true"
            [disabled]="schema.readOnly||false"
          ></p-checkbox>
        </div>
      </div>
  `,
  styleUrls: ['./custom-widgets-styles.css']
})
export class CheckboxWidget extends ControlWidget{

}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/checkbox.widget.ts